import React, {useState} from "react";
import {Form, Input} from "antd";
import Button from "@common/Button";

const AccountSettingsClassKey = props => {
    const {checkFormStatus, handleSubmitForm} = props;
    const [submittable, setSubmittable] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [form] = Form.useForm();

    const handleSubmitFormWrapper = (values) => {
        setDisabled(true);
        handleSubmitForm(form, values, {}, '/web/ui/accountSettings/connectWithClassCode', () => {
            setDisabled(false);
            displayToastMessage('Update successful', '', 'success', undefined, 4000);
            form.setFieldValue('classCode', '');
        }, () => {
            setDisabled(false);
        });
    };

    return (
        <>
            <h3>Class key</h3>
            <p>A class key is used to assign students to a class. Class keys are a randomly generated word followed by
                three digits, for example 'apple123'.
                If you are not assigned to a class, ask your teacher for the class key and enter it below.</p>
            <Form
                name="classCode"
                form={form}
                layout="vertical"
                onFieldsChange={() => setSubmittable(checkFormStatus(form))}
                onFinish={handleSubmitFormWrapper}
                initialValues={{
                    classCode: ''
                }}
            >
                <Form.Item
                    label="Class Key"
                    name="classCode"
                    rules={[{required: true, message: 'Enter a class key to update your class'}]}
                    validateTrigger="onBlur"
                >
                    <Input/>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" disabled={disabled ? disabled : !submittable}>
                        Submit class key
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default AccountSettingsClassKey